<ng-container *ngIf="studyNote?.isDeleting !== true" [ngSwitch]="state.mode">
  <rl-inline-note
    *ngSwitchCase="StudyNoteMode.VIEW"
    [noteType]="InlineNoteEditorType.PERSONAL"
    [note]="studyNote.note"
  >
  </rl-inline-note>

  <rl-inline-note-editor
    *ngSwitchDefault
    [noteType]="InlineNoteEditorType.PERSONAL"
    [note]="studyNote?.note"
    (save)="onSubmit($event)"
    (cancel)="onCancel()"
    (delete)="onDelete()"
  >
  </rl-inline-note-editor>
</ng-container>
